/* CAFFREY Cedar Shoe Trees — buy box behaviour. Express finish (Claude Code, launch agent, 2026-10-07).
   Sizes -> the form's hidden [name=id] (+ a bubbling change event for the kit sticky bar and Shop Pay), price,
   ?variant= URL, quantity stepper, and the "choose your size first" prompt: nothing is preselected (wrong size is the
   category's first return reason), so until a size is chosen "Add to cart", Shop Pay and the kit sticky bar
   ("Choose your size") lead to the sizes with a short message. Adding to the cart is Dawn's <product-form>
   (AJAX + cart notification/drawer). Hero zoom dialog. No dependencies; respects prefers-reduced-motion. */
(() => {
  if (window.CaffreyCedar) { window.CaffreyCedar.refresh(); return; }
  const reduced = () => window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  const st = { root: null, form: null, opener: null, sticky: null, stickyObs: null, tries: 0 };
  const radios = () => st.root ? [...st.root.querySelectorAll('[data-ct-size]')] : [];
  const selected = () => radios().find(r => r.checked && !r.disabled) || null;
  const firstSize = () => radios().find(r => !r.disabled) || null;
  const idInput = () => st.form && st.form.querySelector('[data-ct-id]');
  const addButton = () => st.form && st.form.querySelector('[data-cf-atc]');
  const errorEl = () => st.root && st.root.querySelector('[data-ct-error]');
  const sizesEl = () => st.root && st.root.querySelector('[data-ct-sizes]');

  function choose(radio, updateURL) {
    const input = idInput();
    if (!input) return;
    const id = radio ? radio.value : '';
    if (input.value !== id) { input.value = id; input.dispatchEvent(new Event('change', { bubbles: true })); }
    if (radio && radio.dataset.price) st.root.querySelectorAll('[data-ct-price]').forEach(el => { el.textContent = radio.dataset.price; });
    const add = addButton();
    if (add) {
      const ok = radio ? radio.dataset.available === 'true' : !!firstSize();
      if (!add.classList.contains('loading')) add.disabled = !ok;
      const label = add.querySelector('span');
      if (label) label.textContent = ok ? st.root.dataset.add : st.root.dataset.sold;
    }
    // Shopify greys Shop Pay while the form has no id and a disabled button fires no click: a transparent guard covers it
    // and asks for a size instead, until one is chosen (pattern from Walk On Air).
    const guard = st.root.querySelector('[data-ct-pay-guard]');
    if (guard) guard.hidden = !!radio || !firstSize();
    if (radio) clearError();
    if (updateURL && radio && window.history && history.replaceState) {
      try { const u = new URL(location.href); u.searchParams.set('variant', radio.value); history.replaceState(history.state, '', u.toString()); } catch (e) { /* ignore */ }
    }
    patchSticky();
  }

  function clearError() {
    const el = errorEl(); const box = sizesEl();
    if (el) { el.textContent = ''; el.hidden = true; el.classList.remove('is-new'); }
    if (box) box.removeAttribute('aria-invalid');
  }

  function headerOffset() {
    const header = document.querySelector('sticky-header, .section-header');
    if (!header) return 0;
    const r = header.getBoundingClientRect();
    return r.bottom > 0 && r.top <= 0 ? r.bottom : (r.top >= 0 && r.top < 4 ? r.bottom : 0);
  }

  function reveal(box) {
    const r = box.getBoundingClientRect();
    const top = Math.max(headerOffset(), 0) + 12;
    const bottom = innerHeight - 12 - (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--cf-bottom-overlay')) || 0);
    if (r.top >= top && r.bottom <= bottom) return;
    const y = scrollY + r.top - Math.max(top, (innerHeight - r.height) / 2);
    window.scrollTo({ top: Math.max(0, y), behavior: reduced() ? 'auto' : 'smooth' });
  }

  function showError(message, target) {
    const el = errorEl(); const box = sizesEl();
    if (!el || !box) return;
    el.classList.remove('is-new');
    el.textContent = '';
    el.hidden = false;
    box.setAttribute('aria-invalid', 'true');
    requestAnimationFrame(() => { el.textContent = message; el.classList.add('is-new'); });
    reveal(box);
    if (target) target.focus({ preventScroll: true });
  }

  function stickyDone() {
    const bar = document.querySelector('cf-kit-sticky');
    if (bar && typeof bar.done === 'function') bar.done();
  }

  // Capture at the document: runs before Dawn's <product-form> submit handler on the form itself.
  document.addEventListener('submit', event => {
    if (!st.form || event.target !== st.form) return;
    let message = '', target = null;
    if (!selected()) { message = st.root.dataset.sizeError; target = firstSize(); }
    else {
      const qty = st.form.querySelector('[name="quantity"]');
      if (qty && (!qty.checkValidity() || Number(qty.value) < 1)) { message = st.root.dataset.quantityError; target = qty; }
    }
    if (!message) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (target && target.matches('[name="quantity"]')) {
      const fe = st.form.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
      if (fe) { fe.hidden = false; fe.querySelector('.product-form__error-message').textContent = message; }
      target.focus();
    } else showError(message, target);
    stickyDone();
  }, true);

  document.addEventListener('click', event => {
    if (!st.root) return;
    // Shop Pay before a size (the guard button, or Enter on "More payment options"): lead to the sizes instead
    const pay = event.target.closest('[data-ct-pay]');
    if (pay && st.root.contains(pay) && !selected()) {
      event.preventDefault();
      event.stopPropagation();
      showError(st.root.dataset.sizeError, firstSize());
      return;
    }
    const step = event.target.closest('[data-ct-qty]');
    if (step && st.root.contains(step)) {
      const qty = st.form && st.form.querySelector('[name="quantity"]');
      if (qty) {
        qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + Number(step.dataset.ctQty));
        qty.dispatchEvent(new Event('change', { bubbles: true }));
        const fe = st.form.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
        if (fe) fe.hidden = true;
      }
      return;
    }
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    const zoom = event.target.closest('[data-ct-zoom]');
    if (zoom && st.root.contains(zoom)) {
      const dialog = st.root.querySelector('[data-ct-dialog]');
      if (dialog && dialog.showModal) { event.preventDefault(); st.opener = zoom; dialog.showModal(); document.documentElement.classList.add('cf-ct-modal-open'); }
      return;
    }
    if (event.target.closest('[data-ct-close]') || event.target.matches('[data-ct-dialog]')) st.root.querySelector('[data-ct-dialog]')?.close();
  }, true);

  document.addEventListener('change', event => {
    if (event.target.matches && event.target.matches('[data-ct-size]') && st.root && st.root.contains(event.target)) choose(event.target, true);
  });

  document.addEventListener('close', event => {
    if (!event.target.matches || !event.target.matches('[data-ct-dialog]')) return;
    document.documentElement.classList.remove('cf-ct-modal-open');
    st.opener?.focus();
  }, true);

  /* The kit sticky bar treats "no variant" as unavailable. With nothing preselected it shows "Choose your size" and keeps
     its "Add to cart" active: that clicks the main button, whose check leads the shopper to the sizes. */
  function patchSticky() {
    const bar = st.sticky;
    if (!bar || selected() || !firstSize()) return;
    const btn = bar.querySelector('[data-cf-sticky-atc]');
    const label = btn && btn.querySelector('span');
    const variant = bar.querySelector('[data-cf-sticky-variant]');
    if (btn && btn.disabled && !btn.classList.contains('loading')) btn.disabled = false;
    if (label && label.textContent !== st.root.dataset.add) label.textContent = st.root.dataset.add;
    if (variant && variant.textContent !== st.root.dataset.choose) variant.textContent = st.root.dataset.choose;
  }
  function watchSticky() {
    const bar = document.querySelector('cf-kit-sticky');
    if (!bar) { if (++st.tries < 24) setTimeout(watchSticky, 250); return; }
    if (st.sticky === bar) return;
    st.stickyObs?.disconnect();
    st.sticky = bar;
    st.stickyObs = new MutationObserver(patchSticky);
    st.stickyObs.observe(bar, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
    patchSticky();
  }

  function refresh() {
    st.root = document.querySelector('[data-ct-root]');
    st.form = st.root ? document.getElementById(st.root.dataset.form) : null;
    if (!st.root || !st.form) return;
    const input = idInput();
    if (input) input.disabled = false;
    st.root.dataset.ctReady = 'true';
    choose(selected(), false);
    st.tries = 0;
    watchSticky();
  }

  window.addEventListener('pageshow', () => { if (st.root) choose(selected(), false); });
  window.addEventListener('popstate', () => {
    if (!st.root) return;
    const id = new URL(location.href).searchParams.get('variant');
    const radio = radios().find(r => r.value === id && !r.disabled);
    if (radio) { radio.checked = true; choose(radio, false); }
  });
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', () => { document.documentElement.classList.remove('cf-ct-modal-open'); queueMicrotask(refresh); });
  document.addEventListener('shopify:block:select', event => event.target.closest && event.target.closest('details')?.setAttribute('open', ''));
  window.CaffreyCedar = { refresh };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true }); else refresh();
})();
